import { useEffect, useState } from "react";

/**
 * Volgt een CSS-mediaquery in React-state.
 *
 * LET OP: het mobiele breekpunt (900px) staat hiermee op twee plekken — in
 * styles.css én in de aanroepende component. Dat is een bewuste ruil: het
 * alternatief (een CSS-variabele uitlezen en parsen bij het opstarten) is meer
 * machinerie dan het waard is voor één getal. Wijzig je het breekpunt, wijzig
 * het dan op beide plekken.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent): void => setMatches(e.matches);
    mql.addEventListener("change", onChange);
    setMatches(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
